<template>
  <div class="vehicle-general-main">
    <div class="flex-row">
      <Dropdown placeholder="Category" ref="VehicleCategory" :selectedObject.sync="data.selectedCategory" :items="data.categoryItems" @selected="categorySelected"
        :search.sync="data.categorySearch" :isDisabled="viewMode" :isRequired="true" style="padding-right: 10px;" itemKey="combineKey"/>
      <Input placeholder="Model" :inputValue.sync="data.model" :isDisabled="viewMode" />  
    </div>

    <div class="flex-row">
      <Dropdown placeholder="Type" :selectedObject.sync="data.selectedCategory" :items.sync="data.typeItems"
        :search.sync="data.typeSearch" :isDisabled="true" style="padding-right: 10px;" itemKey="Type Description"/>
      <Dropdown placeholder="Trailer No" :selectedObject.sync="data.selectedTrailerNo" :items="data.trailernoItems"
        :search.sync="data.trailernoSearch" :isDisabled="viewMode" @selected="trailerSelected"/> 
    </div>

    <div class="flex-row">
      <Input placeholder="Year" :inputValue.sync="data.year" :isDisabled="viewMode" style="padding-right: 10px;"/>  
      <Input placeholder="Trailer Model" :inputValue.sync="data.trailermodel" :isDisabled="viewMode" />  
    </div>

    <DateTimePicker title="Date Purchase" :showTime="false" style="justify-content: flex-start; padding-left: 5px;" :value.sync="data.datepurchase" :isDisabled="viewMode" />

    <Dropdown placeholder="Made In" :selectedObject.sync="data.madein" :items="data.madeinItems" :search.sync="data.madeinSearch" :isDisabled="viewMode" /> 

    <div class="flex-row">
      <Input placeholder="Colour" :inputValue.sync="data.colour" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Dropdown placeholder="Company" ref="Company_code" :selectedObject.sync="data.selectedCompany" :items="data.companyItems"
        :search.sync="data.companySearch" :isDisabled="viewMode" :isRequired="true"/> 
    </div> 

    <div class="flex-row">
      <Input placeholder="Weight (Kg)" :inputValue.sync="data.weight_kg" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Dropdown placeholder="Ownership" ref="OwnerShip" :selectedObject.sync="data.selectedOwnership" :items="data.ownershipItems"
        :search.sync="data.ownershipSearch" :isDisabled="viewMode" :isRequired="true"/> 
    </div> 

    <div class="flex-row">
      <Input placeholder="Width (Feet)" :inputValue.sync="data.width_feet" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Supplier" :inputValue.sync="data.supplier" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Input placeholder="Length (Feet)" :inputValue.sync="data.length_feet" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Price (RM)" :inputValue.sync="data.price_rm" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Input placeholder="Height (Feet)" :inputValue.sync="data.height_feet" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Loan From" :inputValue.sync="data.loanfrom" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Input placeholder="Max. Capacity (M3)" :inputValue.sync="data.maxcapacity_m3" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Reg Card No" :inputValue.sync="data.regcardno" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Input placeholder="Winch Capacity (M3)" :inputValue.sync="data.winchcapacity_m3" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Reg Place" :inputValue.sync="data.regplace" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Input placeholder="Ground Clearance" :inputValue.sync="data.groundclearance" :isDisabled="viewMode" style="padding-right: 10px;"/> 
      <Input placeholder="Opening Mileage" :inputValue.sync="data.openingmileage" :isDisabled="viewMode" /> 
    </div>  

    <div class="flex-row">
      <Dropdown placeholder="Depreciation Type" :selectedObject.sync="data.selectedDepreciationType" :items="data.depreciationtypeItems"
        :search.sync="data.depreciationtypeSearch" :isDisabled="viewMode" style="padding-right: 10px; width: calc(50% + 7px);"/>
      <Dropdown placeholder="Team" :selectedObject.sync="data.team" :items="data.teamItems"
        :search.sync="data.teamSearch" :isDisabled="viewMode" style="width: calc(50% - 80px);"/> 
      <CheckBox title="Side Loader" :isDisabled="viewMode" :isChecked.sync="data.SideLoader" style="padding-left: 10px; width: 80px;"/>
    </div>

    <Input placeholder="Pic / Doc" :inputValue.sync="data.pic_doc" :isDisabled="viewMode" /> 

    <div>
      <span style="font-size: 12px; font-style: Italic;"> Document List:</span>
      <div style="width: 100%; height: 50px; border: 1px solid darkgrey;"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import CheckBox from '@/components/CheckBox.vue';

export default {
  components: {
    Input, Dropdown, DateTimePicker, CheckBox
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },
  },
  methods: {
    categorySelected: function(e) {
      this.data.selectedType = e;
      this.data.typeSearch = e['Type Description'].trim().toUpperCase();
    },
    trailerSelected: function(e) {
      this.data.trailermodel = e['Model'].trim().toUpperCase();
    },
  },
  mounted() {
    this.$bus.$on('vehicleGeneralFocusElement', (element) => {
      this.$refs[element].setFocus();
    });
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
}
</style>